export default "__VITE_ASSET__a49a9186__"